import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import creators9cfa95 from './creators'
import members79483b from './members'
import auditsEa940e from './audits'
import settings69f00b from './settings'
import apiManagementAfab3b from './api-management'
import packages418416 from './packages'
import newsletters2fb465 from './newsletters'
import landingPages64f482 from './landing-pages'
/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:21
* @route '/app/admin'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/app/admin',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:21
* @route '/app/admin'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:21
* @route '/app/admin'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:21
* @route '/app/admin'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:21
* @route '/app/admin'
*/
const dashboardForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:21
* @route '/app/admin'
*/
dashboardForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:21
* @route '/app/admin'
*/
dashboardForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dashboard.form = dashboardForm

/**
* @see \App\Http\Controllers\Admin\CreatorController::__invoke
* @see app/Http/Controllers/Admin/CreatorController.php:22
* @route '/app/admin/creators'
*/
export const creators = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: creators.url(options),
    method: 'get',
})

creators.definition = {
    methods: ["get","head"],
    url: '/app/admin/creators',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\CreatorController::__invoke
* @see app/Http/Controllers/Admin/CreatorController.php:22
* @route '/app/admin/creators'
*/
creators.url = (options?: RouteQueryOptions) => {
    return creators.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CreatorController::__invoke
* @see app/Http/Controllers/Admin/CreatorController.php:22
* @route '/app/admin/creators'
*/
creators.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: creators.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::__invoke
* @see app/Http/Controllers/Admin/CreatorController.php:22
* @route '/app/admin/creators'
*/
creators.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: creators.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::__invoke
* @see app/Http/Controllers/Admin/CreatorController.php:22
* @route '/app/admin/creators'
*/
const creatorsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: creators.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::__invoke
* @see app/Http/Controllers/Admin/CreatorController.php:22
* @route '/app/admin/creators'
*/
creatorsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: creators.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::__invoke
* @see app/Http/Controllers/Admin/CreatorController.php:22
* @route '/app/admin/creators'
*/
creatorsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: creators.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

creators.form = creatorsForm

/**
* @see \App\Http\Controllers\Admin\MemberController::__invoke
* @see app/Http/Controllers/Admin/MemberController.php:19
* @route '/app/admin/members'
*/
export const members = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: members.url(options),
    method: 'get',
})

members.definition = {
    methods: ["get","head"],
    url: '/app/admin/members',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\MemberController::__invoke
* @see app/Http/Controllers/Admin/MemberController.php:19
* @route '/app/admin/members'
*/
members.url = (options?: RouteQueryOptions) => {
    return members.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MemberController::__invoke
* @see app/Http/Controllers/Admin/MemberController.php:19
* @route '/app/admin/members'
*/
members.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: members.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MemberController::__invoke
* @see app/Http/Controllers/Admin/MemberController.php:19
* @route '/app/admin/members'
*/
members.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: members.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\MemberController::__invoke
* @see app/Http/Controllers/Admin/MemberController.php:19
* @route '/app/admin/members'
*/
const membersForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: members.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MemberController::__invoke
* @see app/Http/Controllers/Admin/MemberController.php:19
* @route '/app/admin/members'
*/
membersForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: members.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MemberController::__invoke
* @see app/Http/Controllers/Admin/MemberController.php:19
* @route '/app/admin/members'
*/
membersForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: members.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

members.form = membersForm

/**
* @see \App\Http\Controllers\Admin\PaymentOpsController::__invoke
* @see app/Http/Controllers/Admin/PaymentOpsController.php:17
* @route '/app/admin/payment-ops'
*/
export const paymentOps = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: paymentOps.url(options),
    method: 'get',
})

paymentOps.definition = {
    methods: ["get","head"],
    url: '/app/admin/payment-ops',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\PaymentOpsController::__invoke
* @see app/Http/Controllers/Admin/PaymentOpsController.php:17
* @route '/app/admin/payment-ops'
*/
paymentOps.url = (options?: RouteQueryOptions) => {
    return paymentOps.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PaymentOpsController::__invoke
* @see app/Http/Controllers/Admin/PaymentOpsController.php:17
* @route '/app/admin/payment-ops'
*/
paymentOps.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: paymentOps.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PaymentOpsController::__invoke
* @see app/Http/Controllers/Admin/PaymentOpsController.php:17
* @route '/app/admin/payment-ops'
*/
paymentOps.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: paymentOps.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\PaymentOpsController::__invoke
* @see app/Http/Controllers/Admin/PaymentOpsController.php:17
* @route '/app/admin/payment-ops'
*/
const paymentOpsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: paymentOps.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PaymentOpsController::__invoke
* @see app/Http/Controllers/Admin/PaymentOpsController.php:17
* @route '/app/admin/payment-ops'
*/
paymentOpsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: paymentOps.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PaymentOpsController::__invoke
* @see app/Http/Controllers/Admin/PaymentOpsController.php:17
* @route '/app/admin/payment-ops'
*/
paymentOpsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: paymentOps.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

paymentOps.form = paymentOpsForm

/**
* @see \App\Http\Controllers\Admin\AuditController::__invoke
* @see app/Http/Controllers/Admin/AuditController.php:20
* @route '/app/admin/audits'
*/
export const audits = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: audits.url(options),
    method: 'get',
})

audits.definition = {
    methods: ["get","head"],
    url: '/app/admin/audits',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\AuditController::__invoke
* @see app/Http/Controllers/Admin/AuditController.php:20
* @route '/app/admin/audits'
*/
audits.url = (options?: RouteQueryOptions) => {
    return audits.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AuditController::__invoke
* @see app/Http/Controllers/Admin/AuditController.php:20
* @route '/app/admin/audits'
*/
audits.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: audits.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::__invoke
* @see app/Http/Controllers/Admin/AuditController.php:20
* @route '/app/admin/audits'
*/
audits.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: audits.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::__invoke
* @see app/Http/Controllers/Admin/AuditController.php:20
* @route '/app/admin/audits'
*/
const auditsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: audits.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::__invoke
* @see app/Http/Controllers/Admin/AuditController.php:20
* @route '/app/admin/audits'
*/
auditsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: audits.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AuditController::__invoke
* @see app/Http/Controllers/Admin/AuditController.php:20
* @route '/app/admin/audits'
*/
auditsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: audits.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

audits.form = auditsForm

/**
* @see \App\Http\Controllers\Admin\SystemSettingsController::settings
* @see app/Http/Controllers/Admin/SystemSettingsController.php:37
* @route '/app/admin/settings'
*/
export const settings = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(options),
    method: 'get',
})

settings.definition = {
    methods: ["get","head"],
    url: '/app/admin/settings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\SystemSettingsController::settings
* @see app/Http/Controllers/Admin/SystemSettingsController.php:37
* @route '/app/admin/settings'
*/
settings.url = (options?: RouteQueryOptions) => {
    return settings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SystemSettingsController::settings
* @see app/Http/Controllers/Admin/SystemSettingsController.php:37
* @route '/app/admin/settings'
*/
settings.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SystemSettingsController::settings
* @see app/Http/Controllers/Admin/SystemSettingsController.php:37
* @route '/app/admin/settings'
*/
settings.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: settings.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\SystemSettingsController::settings
* @see app/Http/Controllers/Admin/SystemSettingsController.php:37
* @route '/app/admin/settings'
*/
const settingsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: settings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SystemSettingsController::settings
* @see app/Http/Controllers/Admin/SystemSettingsController.php:37
* @route '/app/admin/settings'
*/
settingsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: settings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SystemSettingsController::settings
* @see app/Http/Controllers/Admin/SystemSettingsController.php:37
* @route '/app/admin/settings'
*/
settingsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: settings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

settings.form = settingsForm

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::apiManagement
* @see app/Http/Controllers/Admin/ApiManagementController.php:17
* @route '/app/admin/api-management'
*/
export const apiManagement = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: apiManagement.url(options),
    method: 'get',
})

apiManagement.definition = {
    methods: ["get","head"],
    url: '/app/admin/api-management',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::apiManagement
* @see app/Http/Controllers/Admin/ApiManagementController.php:17
* @route '/app/admin/api-management'
*/
apiManagement.url = (options?: RouteQueryOptions) => {
    return apiManagement.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::apiManagement
* @see app/Http/Controllers/Admin/ApiManagementController.php:17
* @route '/app/admin/api-management'
*/
apiManagement.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: apiManagement.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::apiManagement
* @see app/Http/Controllers/Admin/ApiManagementController.php:17
* @route '/app/admin/api-management'
*/
apiManagement.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: apiManagement.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::apiManagement
* @see app/Http/Controllers/Admin/ApiManagementController.php:17
* @route '/app/admin/api-management'
*/
const apiManagementForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: apiManagement.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::apiManagement
* @see app/Http/Controllers/Admin/ApiManagementController.php:17
* @route '/app/admin/api-management'
*/
apiManagementForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: apiManagement.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::apiManagement
* @see app/Http/Controllers/Admin/ApiManagementController.php:17
* @route '/app/admin/api-management'
*/
apiManagementForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: apiManagement.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

apiManagement.form = apiManagementForm

/**
* @see \App\Http\Controllers\Admin\PackageController::packages
* @see app/Http/Controllers/Admin/PackageController.php:19
* @route '/app/admin/packages'
*/
export const packages = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: packages.url(options),
    method: 'get',
})

packages.definition = {
    methods: ["get","head"],
    url: '/app/admin/packages',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\PackageController::packages
* @see app/Http/Controllers/Admin/PackageController.php:19
* @route '/app/admin/packages'
*/
packages.url = (options?: RouteQueryOptions) => {
    return packages.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PackageController::packages
* @see app/Http/Controllers/Admin/PackageController.php:19
* @route '/app/admin/packages'
*/
packages.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: packages.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::packages
* @see app/Http/Controllers/Admin/PackageController.php:19
* @route '/app/admin/packages'
*/
packages.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: packages.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::packages
* @see app/Http/Controllers/Admin/PackageController.php:19
* @route '/app/admin/packages'
*/
const packagesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: packages.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::packages
* @see app/Http/Controllers/Admin/PackageController.php:19
* @route '/app/admin/packages'
*/
packagesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: packages.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PackageController::packages
* @see app/Http/Controllers/Admin/PackageController.php:19
* @route '/app/admin/packages'
*/
packagesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: packages.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

packages.form = packagesForm

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::newsletters
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:19
* @route '/app/admin/newsletters'
*/
export const newsletters = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: newsletters.url(options),
    method: 'get',
})

newsletters.definition = {
    methods: ["get","head"],
    url: '/app/admin/newsletters',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::newsletters
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:19
* @route '/app/admin/newsletters'
*/
newsletters.url = (options?: RouteQueryOptions) => {
    return newsletters.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::newsletters
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:19
* @route '/app/admin/newsletters'
*/
newsletters.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: newsletters.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::newsletters
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:19
* @route '/app/admin/newsletters'
*/
newsletters.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: newsletters.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::newsletters
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:19
* @route '/app/admin/newsletters'
*/
const newslettersForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: newsletters.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::newsletters
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:19
* @route '/app/admin/newsletters'
*/
newslettersForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: newsletters.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdminNewsletterController::newsletters
* @see app/Http/Controllers/Admin/AdminNewsletterController.php:19
* @route '/app/admin/newsletters'
*/
newslettersForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: newsletters.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

newsletters.form = newslettersForm

/**
* @see \App\Http\Controllers\Admin\LandingPageController::landingPages
* @see app/Http/Controllers/Admin/LandingPageController.php:18
* @route '/app/admin/landing-pages'
*/
export const landingPages = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: landingPages.url(options),
    method: 'get',
})

landingPages.definition = {
    methods: ["get","head"],
    url: '/app/admin/landing-pages',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LandingPageController::landingPages
* @see app/Http/Controllers/Admin/LandingPageController.php:18
* @route '/app/admin/landing-pages'
*/
landingPages.url = (options?: RouteQueryOptions) => {
    return landingPages.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LandingPageController::landingPages
* @see app/Http/Controllers/Admin/LandingPageController.php:18
* @route '/app/admin/landing-pages'
*/
landingPages.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: landingPages.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::landingPages
* @see app/Http/Controllers/Admin/LandingPageController.php:18
* @route '/app/admin/landing-pages'
*/
landingPages.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: landingPages.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::landingPages
* @see app/Http/Controllers/Admin/LandingPageController.php:18
* @route '/app/admin/landing-pages'
*/
const landingPagesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: landingPages.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::landingPages
* @see app/Http/Controllers/Admin/LandingPageController.php:18
* @route '/app/admin/landing-pages'
*/
landingPagesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: landingPages.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::landingPages
* @see app/Http/Controllers/Admin/LandingPageController.php:18
* @route '/app/admin/landing-pages'
*/
landingPagesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: landingPages.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

landingPages.form = landingPagesForm

const admin = {
    dashboard: Object.assign(dashboard, dashboard),
    creators: Object.assign(creators, creators9cfa95),
    members: Object.assign(members, members79483b),
    paymentOps: Object.assign(paymentOps, paymentOps),
    audits: Object.assign(audits, auditsEa940e),
    settings: Object.assign(settings, settings69f00b),
    apiManagement: Object.assign(apiManagement, apiManagementAfab3b),
    packages: Object.assign(packages, packages418416),
    newsletters: Object.assign(newsletters, newsletters2fb465),
    landingPages: Object.assign(landingPages, landingPages64f482),
}

export default admin